<template>
  <Head title="Login" />
  <div class="estat-login">
    <section class="estat-login-form">
      <div class="estat-login-brand"><Logo style="width: 170px; height: 84px;" /></div>
      <form @submit.prevent="login">
        <h1>Login to ESTAT</h1><p class="estat-login-subtitle">ECoS Energy Statistics Hub</p>
        <p v-if="$page.props.flash && $page.props.flash.error" class="staff-login-error" role="alert">{{ $page.props.flash.error }}</p>
        <text-input v-model="form.email" :error="form.errors.email" class="mt-8" label="Email" type="email" autofocus autocapitalize="off" autocomplete="username" />
        <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" autocomplete="current-password" />
        <div class="estat-login-options"><label><input v-model="form.remember" type="checkbox" /> Remember me</label><a href="/forgot-password">Forgot Password?</a></div>
        <loading-button :loading="form.processing" class="btn-indigo estat-login-submit" type="submit">Login</loading-button>
        <div class="staff-google-divider"><span>or</span></div>
        <a href="/staff/google/redirect" class="staff-google-button"><span class="google-g" aria-hidden="true">G</span><span>ECoS Staff</span></a>
        <p class="staff-google-help">For registered ECoS staff using their @ecos.gov.my Google account.</p>
        <p class="estat-login-register">New to ESTAT? <a href="/signup">New User Registration</a></p>
      </form>
    </section>
    <aside class="estat-login-visual"><div><span class="estat-eyebrow">SABAH ENERGY DATA</span><h2>Insights for a<br />sustainable future.</h2><p>Collect, manage and explore Sabah’s energy statistics in one place.</p></div></aside>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>

<style scoped>
.staff-google-divider { display:flex; align-items:center; gap:14px; color:#8091a4; font-size:13px; margin:24px 0 18px; }
.staff-google-divider::before,.staff-google-divider::after { content:''; height:1px; background:#e2eaf0; flex:1; }
.staff-google-button { display:flex; justify-content:center; align-items:center; gap:12px; width:100%; border:1px solid #cbdfe6; border-radius:9px; padding:12px 18px; color:#006483; background:#fff; font-size:16px; font-weight:600; text-decoration:none; }
.staff-google-button:hover { background:#edf6f8; border-color:#006483; }.staff-google-button:focus-visible { outline:2px solid #006483; outline-offset:3px; }
.google-g { font-size:25px; line-height:1; font-weight:700; font-family:Arial,sans-serif; color:#263238; }
.staff-google-help { color:#63758a; font-size:12px; line-height:1.6; text-align:center; margin:12px 0 0; }
.staff-login-error { background:#fff0ee; color:#b42318; padding:12px 14px; border-radius:8px; margin-top:20px; font-size:14px; line-height:1.6; }
</style>
